// Email pattern, scary
export const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// No spaces or special characters
export const username = /^[a-z0-9_-]{6,25}$/

// Hexadecimal value, check color
export const hex = /^#?([a-f0-9]{6}|[a-f0-9]{3})$/

// Phone value
// export const phone = /^#?([0-9]{10})$/
export const phone = /^([0-9]{2})([.-\s]?)([0-9]{2})([.-\s]?)([0-9]{2})([.-\s]{0,1})([0-9]{2})([.-\s]{0,1})([0-9]{2})$/

// Date value
// export const date = /^([0-9]{2})-?([0-9]{2})-?([0-9]{4})$/
export const date = /^([0-9]{2})\/?([0-9]{2})\/?([0-9]{4})$/

// Secu number
// export const secu = /^([0-9]{15})$/
export const secu = /^([0-9]{1})([.-\s]?)([0-9]{2})([.-\s]?)([0-9]{2})([.-\s]?)([0-9]{2})([.-\s]?)([0-9]{3})([.-\s]?)([0-9]{3})([.-\s]?)([0-9]{2})$/



// WEBPACK FOOTER //
// ./src/validations/patterns.js